import { render, staticRenderFns } from "./mermaid.vue?vue&type=template&id=513bd2b7"
import script from "./mermaid.vue?vue&type=script&lang=js"
export * from "./mermaid.vue?vue&type=script&lang=js"
import style0 from "./mermaid.vue?vue&type=style&index=0&id=513bd2b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports